export const makeEnum = (...enumValues) =>
  Object.freeze(enumValues.reduce(($enum, value) => {
    // eslint-disable-next-line no-param-reassign
    $enum[value] = value;
    return $enum;
  }, {}));
